import App from 'app/app.js';
import 'app/action/ContentChangeAction.js';
import 'app/store/ContentStore.js';
import 'app/service/RouterService.js';

function GetStartedCtrl(ContentStore, ContentChangeAction, RouterService, $scope) {
  var unbinder = ContentChangeAction.register(
    function () {
      this.setZones();
    }.bind(this)
  );

  this.zones = undefined;
  this.setZones = function () {
    var values = ContentStore.getZoneDetails(ContentStore.zones.FIND_PICTURE_DAY);
    if (!!values && !!values.length) {
      this.zones = values.sort(function (a, b) {
        return a.code.localeCompare(b.code);
      });
    } else {
      this.zones = values;
    }
  };

  this.itemClick = function ($event) {
    angular.element($event.currentTarget).toggleClass('active');
  };

  this.getFindPictureDayClick = function ($event) {
    if ($scope.$parent.shoppingCart && $scope.$parent.shoppingCart.pageScope === 'SHOPPING_CART') {
      $scope.$parent.shoppingCart.isFindMyPictureDayShown = true;
      $scope.$parent.shoppingCart.isNeedHelpModalShown = false;
    } else {
      $event.preventDefault();
      $scope.$parent.home.isNeedHelpModalShown = false;
      RouterService.findMyPictureDay();
    }
  };

  this.goToHelp = function () {
    RouterService.goToHelp();
  };

  $scope.$on('$destroy', function () {
    unbinder();
  });

  this.init = function () {
    this.setZones();
  };

  this.goTo = function (id) {
    document.getElementById(id).scrollIntoView();
  };

  this.resolveContentImagePath = function (path) {
    return ContentStore.resolveContentImagePath(path);
  };
}

App.controller('GetStartedCtrl', ['ContentStore', 'ContentChangeAction', 'RouterService', '$scope', GetStartedCtrl]);
